import React, {useEffect} from 'react';
import {useHistory, useLocation} from 'react-router';

export const PastDueHandling = ({isPastDue, updateUrl}) => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    let pastDue =
      location.search.includes('past-due=true') || (isPastDue ?? false);

    let action = hasAction('update-payment-method', location.search);
    if (pastDue && action && updateUrl) {
      Paddle?.Setup?.({
        vendor: 37611,
      });
      Paddle.Checkout.open({
        override: updateUrl,
      });
    }
  }, [isPastDue, updateUrl, location]);

  if (isPastDue) {
    return (
      <a
        href={'#'}
        style={{color: 'white'}}
        onClick={() => {
          history.push(location.pathname + '?action=update-payment-method');
        }}
      >
        Update payment method
      </a>
    );
  } else {
    return <></>;
  }
};

const hasAction = (action: string, search: string) => {
  return new URLSearchParams(search).get('action') === action;
};
